module.exports = __webpack_public_path__ + "img/BAR 02.a23feb39.png";